import { useDispatch } from 'react-redux'
import { ClientData } from '../../../../types/reports'
import { formatCurrency } from '../../../../utils/formatAmount'
import { formatDateRange, formatTimeRange } from '../../../../utils/formatSchedule'
import { setTypeModal } from '../../../../features/modal/modalSlice'

interface ClientListReportProps {
    client: ClientData;
    onOpenModal: () => void;
}

export default function ClientListReport({ client, onOpenModal }: ClientListReportProps) {

    const dispatch = useDispatch();
    const initialName = client.deceasedName[0];
    const scheduleFrom = client.scheduleFrom;
    const scheduleTo = client.scheduleTo;

    const dateRange = formatDateRange(scheduleFrom, scheduleTo);
    const timeRange  = formatTimeRange(scheduleFrom, scheduleTo);

    // const actualSaleClient = client.packageNames.reduce((sum, pkg) => sum + pkg.totalprice, 0);
    // const actualBilledClient = client.packageNames.reduce((sum, pkg) => sum + pkg.packageprice, 0);

    const amountToBeBilled = client.amountToBeBilled;
    const totalPackageSales = client.totalPackageSales

    const handleShowClientReportModal = () => {
        dispatch(setTypeModal('clientReport'));
        onOpenModal();
    }

    const getBorderColorStyle = (scheduleTo: string) => {
        // Convert "YYYY-MM-DD HH:mm:ss" → "YYYY-MM-DDTHH:mm:ss" (ISO format)
        const endDate = new Date(scheduleTo.replace(" ", "T"));
        const now = new Date();

        // Compare dates
        return now <= endDate ? "bg-green-500" : "bg-cbColor";
    };

    return (
        <div 
            onClick={handleShowClientReportModal}
            className="group relative overflow-hidden cursor-pointer rounded border border-gray-200 bg-white shadow-sm transition-all duration-300"
        >
            <div className={`h-1.5 ${getBorderColorStyle(client.scheduleTo)}`} />
            <div className="flex items-center gap-3 px-4 py-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-cbColor text-sm font-semibold text-white">
                    {initialName}
                </div>
                <div className="flex-1 min-w-0">
                    <p className="truncate text-sm uppercase font-semibold text-gray-900">{client.deceasedName}</p>
                    <p className="text-xs text-gray-500">{client?.chapelName}</p>
                </div>
            </div>
            <div className="space-y-3 px-4 pb-4 text-sm text-gray-600">
                <div className="grid grid-cols-2 gap-1.5">
                    <div>
                        <p className="text-xs font-medium text-gray-500 uppercase">DATE</p>
                        <p className="text-xs font-medium text-gray-800">{dateRange}</p>
                    </div>
                    <div>
                        <p className="text-xs font-medium text-gray-500">TIME</p>
                        <p className="text-xs font-medium text-gray-800">{timeRange}</p>
                    </div>
                    <div>
                        <p className="text-xs font-medium text-gray-500">ACTUAL SALES</p>
                        {/* <p className="text-xs font-medium text-gray-800">{`₱${formatCurrency(actualSaleClient)}`}</p> */}
                        <p className="text-xs font-medium text-gray-800">{`₱${formatCurrency(totalPackageSales)}`}</p>
                    </div>
                    <div>
                        <p className="text-xs font-medium text-gray-500">ACTUAL BILLED</p>
                        <p className="text-xs font-medium text-gray-800">{`₱${formatCurrency(amountToBeBilled)}`}</p>
                    </div>
                </div>
                <div>
                    <p className="text-xs font-medium text-gray-500">PACKAGE/S (REMAINING):</p>
                    <div className="space-y-1">
                        {client.packageNames.map((pkg, indx) => {
                            return (
                                <div key={indx}>
                                    <div className="flex justify-between text-xs font-medium">
                                        <span className="text-gray-700">{pkg.packageName}</span>
                                        <span className="text-gray-500">{`${pkg.cupsAvailable}/${pkg.totalquantity}`}</span>
                                    </div>
                                    <div className="mt-1 h-2 w-full rounded bg-gray-200">
                                        <div 
                                            className="h-2 rounded bg-gray-500 transition-all" 
                                            style={{  width: `${(pkg.cupsAvailable / pkg.totalquantity) * 100}%`}}
                                        />
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}
